(() => {
  function init(section) {
    if (!section || section.dataset.rrCroPriceReady) return;
    const select = section.querySelector('[data-rr-variant]');
    const current = section.querySelector('[data-rr-current-price]');
    const compare = section.querySelector('[data-rr-compare-price]');
    const savings = section.querySelector('[data-rr-savings]');
    const main = section.querySelector('[data-rr-main-image]');
    const frame = main?.closest('.rr-pdp-main-image');
    const form = section.querySelector('.rr-product-form');
    const packLabel = form?.querySelector('label[for^="rr-variant-"]');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const buyRow = form?.querySelector('.rr-buy-row');
    if (packLabel) packLabel.textContent = 'Choose your pack';
    if (quantityInput) {
      quantityInput.value = '1';
      quantityInput.setAttribute('value','1');
      quantityInput.parentElement?.setAttribute('hidden','');
      if (buyRow) {
        buyRow.style.gridTemplateColumns = '1fr';
        const buyButton = buyRow.querySelector('[data-rr-buy]');
        if (buyButton) {
          buyButton.style.gridColumn = '1 / -1';
          buyButton.style.width = '100%';
        }
      }
    }
    const setImageMode = mode => {
      if (!main) return;
      const lifestyle = mode === 'lifestyle';
      main.classList.toggle('rr-image-lifestyle', lifestyle);
      frame?.classList.toggle('rr-pdp-main-image--lifestyle', lifestyle);
    };
    if (main?.classList.contains('rr-image-lifestyle')) setImageMode('lifestyle');
    section.querySelectorAll('[data-rr-thumbnail]').forEach(button => button.addEventListener('click', () => setImageMode(button.dataset.mode)));
    if (!select || !current || !compare || !savings) {
      section.dataset.rrCroPriceReady = 'true';
      return;
    }
    section.dataset.rrCroPriceReady = 'true';
    const sync = () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      current.textContent = option.dataset.price || '';
      const comparePrice = option.dataset.comparePrice || '';
      const saved = option.dataset.savings || '';
      compare.textContent = comparePrice;
      compare.hidden = !comparePrice;
      savings.textContent = saved ? `Save ${saved}` : '';
      savings.hidden = !saved;
      setImageMode('product');
    };
    select.addEventListener('change', sync);
    sync();
  }
  const run = root => root.querySelectorAll?.('[data-rr-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document)); else run(document);
  document.addEventListener('shopify:section:load', event => run(event.target));
})();

/* Desktop hover zoom: progressive enhancement. Mobile/touch keeps the normal gallery. */
(() => {
  const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initHoverZoom(section) {
    if (!section || section.dataset.rrPdpHoverZoomReady) return;
    section.dataset.rrPdpHoverZoomReady = 'true';

    /* The old synthetic detail thumbnail is replaced by hover zoom. */
    section.querySelector('.rr-thumbnail--detail')?.remove();

    const main = section.querySelector('[data-rr-main-image]');
    const frame = main?.closest('.rr-pdp-main-image');
    if (!main || !frame || !fineHover.matches) return;

    frame.style.cursor = 'zoom-in';
    frame.style.overflow = 'hidden';
    main.style.transition = reducedMotion.matches ? 'none' : 'transform 160ms ease-out';

    let rafId = 0;
    const setOrigin = event => {
      if (!fineHover.matches) return;
      const rect = frame.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        main.style.transformOrigin = `${x}% ${y}%`;
      });
    };

    const resetZoom = () => {
      cancelAnimationFrame(rafId);
      main.style.transform = '';
      main.style.transformOrigin = '';
      main.style.willChange = '';
    };

    frame.addEventListener('pointerenter', event => {
      if (!fineHover.matches) return;
      main.style.willChange = 'transform';
      main.style.transform = main.classList.contains('rr-image-lifestyle') ? 'scale(1.32)' : 'scale(1.62)';
      setOrigin(event);
    });
    frame.addEventListener('pointermove', setOrigin);
    frame.addEventListener('pointerleave', resetZoom);
    frame.addEventListener('pointercancel', resetZoom);

    section.querySelectorAll('[data-rr-thumbnail]').forEach(button => button.addEventListener('click', resetZoom));
    section.querySelector('[data-rr-variant]')?.addEventListener('change', resetZoom);
  }

  const run = root => root.querySelectorAll?.('[data-rr-product]').forEach(initHoverZoom);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document)); else run(document);
  document.addEventListener('shopify:section:load', event => run(event.target));
})();
